import { adminConfig } from '../config/login/adminConfig';

// Key for storing device trust in localStorage
const DEVICE_TRUST_KEY = 'admin_device_trust';

// Trust duration in days
const TRUST_DURATION_DAYS = 30;

/**
 * Check if the current device is trusted
 * @returns {boolean}
 */
export const isDeviceTrusted = () => {
  try {
    const trustData = localStorage.getItem(DEVICE_TRUST_KEY);
    if (!trustData) return false;

    const { expiresAt, deviceId } = JSON.parse(trustData);
    
    // Check if trust has expired
    if (Date.now() > expiresAt) {
      localStorage.removeItem(DEVICE_TRUST_KEY);
      return false;
    }

    // Check if device ID matches
    const currentDeviceId = getDeviceId();
    if (deviceId !== currentDeviceId) {
      localStorage.removeItem(DEVICE_TRUST_KEY);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error checking device trust:', error);
    return false;
  }
};

/**
 * Trust the current device for the admin security code
 */
export const trustDevice = () => {
  try {
    const expiresAt = Date.now() + (TRUST_DURATION_DAYS * 24 * 60 * 60 * 1000);
    const deviceId = getDeviceId();

    localStorage.setItem(DEVICE_TRUST_KEY, JSON.stringify({
      expiresAt,
      deviceId
    }));
  } catch (error) {
    console.error('Error trusting device:', error);
  }
};

/**
 * Remove device trust
 */
export const removeTrust = () => {
  localStorage.removeItem(DEVICE_TRUST_KEY);
};

/**
 * Get a unique device identifier
 * @returns {string}
 */
const getDeviceId = () => {
  // Use navigator properties to create a semi-unique device identifier
  const components = [
    navigator.userAgent,
    navigator.language,
    navigator.platform,
    window.screen.width,
    window.screen.height,
    new Date().getTimezoneOffset()
  ];

  // Create a hash of the components
  return components.join('|');
}; 